import React from 'react';
import { getLink } from 'components/internal/shared';
import { editInternalReviewGuidePath } from 'utilities/routes';

export function getReviewGuidesDimension(guides) {
  const options = guides.map((guide) => {
    const [id, title] = guide.split('::');

    return {
      label: title,
      url: editInternalReviewGuidePath(id),
      value: id,
    };
  });

  return {
    options,
    value: guides.join(','),
  };
}

export function renderReviewGuideLinks(options) {
  if (options.length === 0) return null;

  return (
    <div className="u-flexRow u-gap-8">
      <div>Review Guides:</div>
      { options.map(({ label, url }, index) => (
        <div key={url}>
          { getLink(url, label, true) }
          { index < options.length - 1 && <span>,</span> }
        </div>
      )) }
    </div>
  );
}
